import { createSelector } from 'reselect';

// Base selector
const permissionsStateSelector = (state) => state.permissions;

// Get all permissions data
export const myPermissionsSelector = createSelector(
    permissionsStateSelector,
    (permissions) => permissions.data || []
);

// Get permissions loading state
export const permissionsLoadingSelector = createSelector(
    permissionsStateSelector,
    (permissions) => permissions.loading
);

// Get permissions error
export const permissionsErrorSelector = createSelector(
    permissionsStateSelector,
    (permissions) => permissions.error
);

// Check if user has a specific permission
export const hasPermissionSelector = createSelector(
    [myPermissionsSelector, (_, permissionName) => permissionName],
    (permissions, permissionName) => {
        return permissions.some((permission) => permission.name === permissionName);
    }
);

// Get permissions as a Set for faster lookup
export const permissionsSetSelector = createSelector(
    myPermissionsSelector,
    (permissions) => new Set(permissions.map((p) => p.name))
);
